/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.0.1
 */

import {
    backgroundColorModal,
    backgroundColorNormal,
    borderColorDisabled,
    ColorGreenDark,
    ColorGrey6,
    ColorWhite,
} from './palette';

export const basketButtonBg = backgroundColorNormal;
export const basketButtonBgHover = ColorGreenDark;
export const basketButtonText = ColorWhite;

export const basketModuleBg = backgroundColorModal;

export const basketItemBg = ColorGrey6;
export const basketItemBorder = borderColorDisabled;
